import api from "../../../api/api"

export interface EventContactsFilterParams {
  sort: string
  order: string
  searchValue: string
  id: number
  statusNumber: string
  waStatusNumber?: string
  reminderNumber: string
}

export const FETCH_ALL_PAGE_SIZE = 100

export async function fetchAllEventContacts(
  params: EventContactsFilterParams,
  pageSize = FETCH_ALL_PAGE_SIZE,
): Promise<any[]> {
  const allGuests: any[] = []
  let page = 1
  let totalPages = 1

  do {
    const response = await api.contacts.getContactsOnEvent(page, pageSize, params)
    const pageGuests = response.data?.data ?? []
    allGuests.push(...pageGuests)
    totalPages = response.data?.meta?.pagination?.total_pages ?? page
    page += 1
  } while (page <= totalPages)

  return allGuests
}
